import { RootState } from '../reducers'

export const getListDevices = (state: RootState) => state.devices.listDevice
export const getFilterDevices = (state: RootState) => state.devices.filter
export const getDeviceSearchState = (state: RootState) =>
  state.devices.searchState
export const getDeviceLoading = (state: RootState) => state.devices.loading
